import React from "react";
import { Helmet } from "react-helmet";
import "./Ourteam.css";
import { GoChevronDown, GoChevronUp } from "react-icons/go";
import abisha from "../../Media/abisha.webp";
import arsath from "../../Media/arsath.webp";
import asiba from "../../Media/asiba.webp";
import brinci from "../../Media/brinci.webp";
import Clarissa from '../../Media/Clarissa.webp'
import hebeya from "../../Media/hebeya.webp";
import irine from "../../Media/Irine.webp";
import jayasree from "../../Media/jayasree.webp";
import jenish from "../../Media/jenish.jpg";
import Sreejith from "../../Media/sree.webp";
import preethi from "../../Media/Preethi.webp"; 
import renjith from "../../Media/renjith.webp";
import selva from "../../Media/selva.webp";
import shaji from "../../Media/shaji.webp";
import tharaniya from "../../Media/tharaniya.webp";
import yuvarani from "../../Media/yuvarani.webp";
import jeeva from '../../Media/jeeva.webp';
import anton from '../../Media/anton.webp';
import varsha from '../../Media/Varsha.webp';
import maybe from "../../Media/Team2.webp";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import { useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

const teamData = [
  { name: "Abisha M", role: "Frontend Developer", image: abisha },
  { name: "Anton Aloy S", role: "FullStack Trainee", image: anton },
  { name: "Arsath Mohammed F", role: "Data Analyst", image: arsath },
  { name: "Asiba A", role: "Marketing Analyst", image: asiba },
  { name: "Brinci N V", role: "Frontend Developer", image: brinci },
  { name: "Clarissa Clifford Lewis", role: "Marketing Executive ", image: Clarissa },
  { name: "Hebeya Salon S K", role: "Data Scientist", image: hebeya },
  { name: "Irine Saranya S", role: "Frontend Developer", image: irine },
];

const teamDatatwo = [
  { name: "Jayasree Ramalekshmi E", role: "Frontend Developer", image: jayasree},
  { name: "Jeeva V", role: "FullStack Developer", image: jeeva },
  { name: "Jenish J", role: "Software Developer", image: jenish },
  { name: "Preethi J P", role: "Frontend Developer", image: preethi },
  { name: "Renjith R", role: "Network Engineer", image: renjith },
  { name: "Selva Nayagam M", role: "Backend Developer", image: selva },
  { name: "Shaji P", role: "Technical Lead", image: shaji },
  { name: "Sreejith T S", role: "UI/UX Designer", image: Sreejith },
  { name: "Swarna Tharaniya P K", role: "HR Executive cum Admin", image: tharaniya},
  { name: "Varsha M", role: "Digital Marketing Executive", image: varsha },
  { name: "Yuvarani R", role: "Business Analyst", image: yuvarani },
  { name: "Maybe You?", role: "Future Innovator", image: maybe },
];

const ResponsiveCarousel = ({ data }) => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true, 
    autoplaySpeed: 3000, 
    pauseOnHover: true,
  };

  const handleRightClick = (e) => {
    e.preventDefault();
  };
  return (
    <div className="carousel-wrapper">
      <Slider {...settings}>
        {data.map((member, index) => (
          <article
            className="team-card"
            itemScope
            itemType="https://schema.org/Person"
            key={index}
            data-aos="fade-up"
            onContextMenu={handleRightClick}
          >
            <img itemProp="image" src={member.image} alt={`${member.name} - ${member.role} at Althi Solutions`} className="team-image" loading="lazy"/>
            <div className="team-info">
              <h3 itemProp="name">{member.name}</h3>
              <p itemProp="jobTitle">{member.role}</p>
            </div>
          </article>
        ))}
      </Slider>
    </div>
  );
};

const Ourteam = () => {
  const [showMore, setShowMore] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 480);

  const [isThreeColumn, setIsThreeColumn] = useState(
    window.innerWidth > 1012 && window.innerWidth <= 1317
  );
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
    const handleResize = () => {
      const width = window.innerWidth;

      setIsMobile(width <= 480);
      setIsThreeColumn(width > 1012 && width <= 1317);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleRightClick = (e) => {
    e.preventDefault();
  };

  // Person structured data for every real team member — tells Google there are
  // real, named experts behind Althi Solutions (E-E-A-T / authority signal).
  const realMembers = [...teamData, ...teamDatatwo].filter(
    (m) => m.name && m.name !== "Maybe You?"
  );
  const teamSchema = {
    "@context": "https://schema.org",
    "@graph": realMembers.map((m) => ({
      "@type": "Person",
      name: m.name,
      jobTitle: m.role.trim(),
      image: `https://www.althisolutions.com${m.image}`,
      worksFor: {
        "@type": "Organization",
        name: "Althi Solutions",
        url: "https://www.althisolutions.com",
      },
    })),
  };

  const initialTeamData = isThreeColumn
  ? [...teamData, teamDatatwo[0]]
  : teamData;

  const remainingTeamData = isThreeColumn
  ? teamDatatwo.slice(1)
  : teamDatatwo;

  return (
    <section id="our-team"
      className="ourteam-section">
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(teamSchema)}
        </script>
      </Helmet>

      <div className="ourteam-section-heading">
        <h2 className="ourteam-section-heading-text who-we-are-animate">What We Believe</h2>
      </div>
      <div className="ourteam-section-content">
        <p className="ourteam-section-content-text who-we-are-animate">
          The company is more important than the journey or destination. So we
          make sure our clients know that the entire Althi Solutions team is
          behind them. 24/7 never stopped us from responding to challenges for
          our clients. Stop by anytime to see our team in action!
        </p>
      </div>

      {isMobile ? (
        <ResponsiveCarousel data={teamData} />
      ) : (
        <div className="team-grid">
          {initialTeamData.map((member, index) => (
            <article
              className="team-card"
              itemScope
              itemType="https://schema.org/Person"
              key={index}
              data-aos="fade-up"
              onContextMenu={handleRightClick}
            >
              <img
                src={member.image}
                itemProp="image"
                alt={`${member.name} - ${member.role} at Althi Solutions`}
                className="team-image"
                loading="lazy"
              />
              <div className="team-info">
                <h3 itemProp="name">{member.name}</h3>
                <p itemProp="jobTitle">{member.role}</p>
              </div>
            </article>
          ))}
        </div>
      )}

      {showMore &&
        (isMobile ? (
          <ResponsiveCarousel data={remainingTeamData} />
        ) : (
          <div id="extended-team" className="team-grid">
            {remainingTeamData.map((member, index) => (
              <article
                className="team-card"
                itemScope
                itemType="https://schema.org/Person"
                key={index}
                data-aos="fade-up"
                onContextMenu={handleRightClick}
              >
                <img
                  src={member.image}
                  itemProp="image"
                  alt={`${member.name} - ${member.role} at Althi Solutions`}
                  className="team-image"
                  loading="lazy"
                />
                <div className="team-info">
                  <h3 itemProp="name">{member.name}</h3>
                  <p itemProp="jobTitle">{member.role}</p>
                </div>
              </article>
            ))}
          </div>
        ))}

      <div className="ourteam-section-button">
        <button type="button" 
          className="Primary-two" 
          onClick={() => setShowMore(!showMore)}     
          aria-expanded={showMore}
          aria-controls="extended-team" 
          aria-label={showMore ? "Show fewer team members" : "Show more team members"}>
          <span className="testing">
            {showMore ? "Show Less" : "Show More"}
          </span>
          {showMore ? <GoChevronUp /> : <GoChevronDown />}
        </button>
      </div>
    </section>
  );
};

export default Ourteam;
